import { render, staticRenderFns } from "./ApprovalConfirmationModal.vue?vue&type=template&id=4a5d9100&scoped=true"
import script from "./ApprovalConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ApprovalConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./ApprovalConfirmationModal.vue?vue&type=style&index=0&id=4a5d9100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5d9100",
  null
  
)

export default component.exports